<div 
    style="top: 0px; z-index: 10024;"
    class="position-absolute bg-white w-100 h-100">

    <div class="d-flex align-items-center justify-content-center w-100 h-100">
        <div class="">
            <div class="d-flex justify-content-center mb-3">
                <div class="spinner-grow" style="width: 6rem; height: 6rem;" role="status">
                <span class="visually-hidden">Loading...</span>
                </div>
            </div>
            <div class="text-center">
                <h3><b>{{ spinnerService.message }}</b></h3>
            </div>
        </div>
    </div>
</div>